import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useSyncExternalStore } from 'react';
import { queryClient } from '~/queryClient';
export const initialAiSearchBaseState = ()=>({
        filter: null,
        lastQuery: '',
        filterEditedSinceLastSearch: false,
        errorCode: null,
        abortInFlight: null
    });
// WHY: reads subscribe to the module-singleton query cache (not context), so getState/setState and reactive reads are one cache in app and tests — the module-global invariant zustand gave for free.
export const createAiSearchStore = (queryKey, initial)=>{
    const key = queryKey;
    // WHY: no QueryObserver ever backs this cache-as-store key, so react-query would GC it after cacheTime and silently reset the store mid-session — disable GC for the key.
    queryClient.setQueryDefaults(key, {
        cacheTime: Infinity
    });
    const getState = ()=>{
        var _queryClient_getQueryData;
        return (_queryClient_getQueryData = queryClient.getQueryData(key)) !== null && _queryClient_getQueryData !== void 0 ? _queryClient_getQueryData : initial;
    };
    const setState = (partial)=>{
        queryClient.setQueryData(key, (previous)=>{
            const current = previous !== null && previous !== void 0 ? previous : initial;
            const patch = typeof partial === 'function' ? partial(current) : partial;
            return _object_spread({}, current, patch);
        });
    };
    const useStore = (selector)=>{
        const state = useSyncExternalStore((onStoreChange)=>queryClient.getQueryCache().subscribe(onStoreChange), getState, getState);
        return selector(state);
    };
    return {
        useStore,
        getState,
        setState
    };
};
export const createAiSearchBaseActions = function createAiSearchBaseActions(store) {
    let searchSettledPatch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        setFilter: (filter, lastQuery)=>store.setState(_object_spread({
                filter,
                lastQuery,
                errorCode: null,
                filterEditedSinceLastSearch: false
            }, searchSettledPatch)),
        clearFilter: ()=>{
            var _store_getState_abortInFlight, _store_getState;
            (_store_getState_abortInFlight = (_store_getState = store.getState()).abortInFlight) === null || _store_getState_abortInFlight === void 0 ? void 0 : _store_getState_abortInFlight.call(_store_getState);
            store.setState(_object_spread({
                filter: null,
                lastQuery: '',
                errorCode: null,
                abortInFlight: null,
                filterEditedSinceLastSearch: false
            }, searchSettledPatch));
        },
        setError: (code)=>store.setState(code == null ? {
                errorCode: null
            } : _object_spread({
                errorCode: code
            }, searchSettledPatch)),
        setAbortInFlight: (abort)=>store.setState({
                abortInFlight: abort
            })
    };
};
